import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=b4a348ca&scoped=true"
import script from "./Documentation.vue?vue&type=script&lang=ts"
export * from "./Documentation.vue?vue&type=script&lang=ts"
import style0 from "./Documentation.vue?vue&type=style&index=0&id=b4a348ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a348ca",
  null
  
)

export default component.exports